import FactSheetSettingsPage from "@app/pages/fact-sheet/fact-sheet-settings-page";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/fact-sheet")({
  head: () => pageHead("Public fact sheet"),
  component: FactSheetSettingsPage,
});
